<template>
    <div>

        <!-- ASIGNAR DEPENDENCIA O PUESTO -->

        <v-dialog
            v-model="mostrar"
            max-width="500"
            fullscreen
            >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Dependencias</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark flat @click="$emit('cerrarAsignacion')">Cerrar</v-btn>
                    </v-toolbar-items>
                </v-toolbar>

                <v-container  fluid grid-list-md>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 md6>
                            <v-card>
                                <v-card-title>
                                    <h3>Disponibles</h3>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="buscarDisp"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                    :headers="headersDep"
                                    :items="dependenciasNA"
                                    :rows-per-page-items="[10,20,30,50,100]"
                                    :no-data-text="tableProps.noData"
                                    :no-results-text="tableProps.noResults"
                                    :rows-per-page-text="tableProps.rowsText"
                                    class="elevation-1"
                                    :search="buscarDisp"
                                >
                                    <template slot="items" slot-scope="props">
                                        <td>{{ props.item.nombre }}</td>
                                        <td>
                                            <v-btn 
                                                flat icon color="green" 
                                                @click="asignarDependencia(props.item._id,props.item.nombre)">
                                                <v-icon>arrow_forward</v-icon>
                                            </v-btn>
                                        </td>
                                    </template>
                                    
                                </v-data-table>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                            <v-card>
                                <v-card-title>
                                    <h3>Asignados</h3>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="buscarAsig"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                    :headers="headersPue"
                                    :items="depAsignadas"
                                    :rows-per-page-items="[10,20,30,50,100]"
                                    :no-data-text="tableProps.noData"
                                    :no-results-text="tableProps.noResults"
                                    :rows-per-page-text="tableProps.rowsText"
                                    class="elevation-1"
                                    :search="buscarAsig"
                                >
                                    <template slot="items" slot-scope="props">
                                        <td>
                                            <v-btn 
                                                flat icon color="red"
                                                @click="quitarDependencia(props.item._id,props.item.nombre)">
                                                <v-icon>arrow_back</v-icon>
                                            </v-btn>
                                        </td>
                                        <td>{{ props.item.nombre }}</td>
                                    </template>
                                    
                                </v-data-table>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios'
import moment from 'moment'
import _ from 'underscore'

export default {
    name: 'Asignaciones',
    props: ['id','mostrar','dependencias','depAsignadas'],
	components: {
	},
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "role",
            "permisos",
            "tableProps"
        ])
    },
    data() {
        return {
            dependenciasList:[],
            puestosList:[],
            asignar:{
                mostrar: false,
                tipo: null,
                selected:[]
            },
            buscarDisp: null,
            buscarAsig: null,
            headersDep:[
                { text: 'Nombre', value: 'nombre' },
                { text: '', value: 'Options', sortable: false }
            ],
            headersPue:[
                { text: '', value: 'Options', sortable: false },
                { text: 'Nombre', value: 'nombre' },
            ],
            dependenciasNA:[],
            puestosNA:[]
        }
    },
    created(){
        //Se obtienen las dependencias
        this.dependenciasList = _.clone(this.dependencias);
        //Se genera la lista de dependencias no asignadas
        this.dependenciasNA = this.dependenciasList;
        // console.log(this.dependenciasNA);
        this.depAsignadas.forEach(element => {
            let index = this.dependenciasNA.findIndex(x=>x._id == element._id);
            if( index >= 0)
                this.dependenciasNA.splice(index,1);
        });
    },
    methods:{
        enviandoStart(){
            this.$emit('enviandoStart');
        },
        enviandoStop(){
            this.$emit('enviandoStop');
        },
        asignarDependencia(id,nombre){
            this.enviandoStart();
            axios.post(this.httpURL+'/festivos/dependencias/'+this.id,
                    {idDep:id,nombre},
                    {headers:{token: this.sessionToken}
                })
                .then(res => {
                    let index = this.dependenciasNA.findIndex(x=>x._id == id);
                    if( index >= 0)
                        this.dependenciasNA.splice(index,1);
                    
                    this.$emit('dependenciaAgregada',{_id:id,nombre})
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        },
        quitarDependencia(id,nombre){
            this.enviandoStart();
            axios.delete(this.httpURL+'/festivos/dependencias/'+this.id,
                    {
                        data: {idDep:id,nombre},
                        headers:{token: this.sessionToken}
                    }
                )
                .then(res => {
                    this.dependenciasNA.push({_id:id,nombre})
                    this.$emit('dependenciaEliminada',id)
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        }
    }
}
</script>